<template>
  <section class="animated-grid">
    <div class="card">
      <div class="top-left"><!--a-->
         <img
          id="top-left"
          src="../assets/drawing4.jpg"
          alt="Plebeyos y Ave "
          style="width: 100%; height: 100%; opacity: 0;"
          v-on:click="test($event)"
        />
      </div>
    </div>
    <div class="card">
      <div class="top-right"><!--b-->
       <img
          id="top-right"
          src="../assets/drawing6.jpg"
          alt="El rescate"
         style="width: 100%; height: 100%; opacity: 0;"
          v-on:click="test($event)"
        />
      </div>
    </div>
    <div class="card">
      <div class="pluma">
        <div>
          <!--pluma-->
           <img
          id="pluma"
          src="../assets/pluma.jpg"
          alt="Pluma"
          style="width: 100%; height: 100%; opacity: 0;"
          v-on:click="test($event)"
        />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="border-4">
        <div class="wrapper-4">
          <div class="angel">Angel</div>
          <div>Contreras</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="bottom-left"><!--e-->
       <img
          id="bottom-left"
          src="../assets/drawing3.jpg"
          alt="Ante el Rey"
          style="width: 100%; height: 100%; opacity: 0;"
          v-on:click="test($event)"
        />
      </div>
    </div>
    <div class="card">
      <div class="bottom-right">
        <!--f-->
        <img
          id="bottom-right"
          src="../assets/drawing5.jpg"
          alt="Oscuro"
         style="width: 100%; height: 100%; opacity: 0;"
          v-on:click="test($event)"
        />
      </div>
    </div>
  </section>

  <div id="myModal" class="modal">
    <span class="close">&times;</span>
    <img class="modal-content" id="img01" />
    <div id="caption"></div>
  </div>

  <!-- The Modal -->

  <!-- The Modal -->
</template>

<script>
import { expand } from "./expand";

export default {
  mounted() {
    //expand();
  },
  methods: {
    test(val){
      expand(val)
    }
  }
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Source+Serif+Pro&display=swap");
@import url("expand.css");
/* * {
  border: 1px solid black;
} */

img {
 
  overflow: hidden;
  background-size: cover;
  background-position: top;
}
#pluma {
  background-position: center;
}


.animated-grid {
  height: 100%;
  width: 100%;
  display: grid;
  gap: 10px;
  grid-template-rows: 20% 5% 10% 5% 20% auto;
  grid-template-columns: 50% 2% 2% 2% auto;
  --stagger-delay: 100ms;
}

@keyframes cardEntrance {
  from {
    opacity: 0;
    transform: scale(0.3);
    filter: hue-rotate(180deg);
  }
  to {
    opacity: 1;
    transform: scale(1);
    filter: hue-rotate(0deg);
  }
}
.card {
  animation: cardEntrance 700ms ease-out;
  animation-fill-mode: backwards;
}

.card:nth-child(1) {
  grid-column: 1 / span 1;
  grid-row: 1 / span 3;
  position: relative;
  animation-delay: calc(2 * var(--stagger-delay));
}

.top-left {
  border: 5px solid black;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 10px;
  margin-left: 15px;
  overflow: hidden;
  background-size: cover;
  background-position: top;
  background-image: url("../assets/drawing4.jpg");
}
.card:nth-child(2) {
  grid-column: 2 / span 4;
  grid-row: 1 / span 1;
  position: relative;
  animation-delay: calc(3 * var(--stagger-delay));
}

.top-right {
  border: 5px solid black;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 10px;
  margin-right: 15px;
  overflow: hidden;
  background-size: cover;
  background-position: top;
  background-image: url("../assets/drawing6.jpg");
}
.card:nth-child(3) {
  grid-column: 5 / span 1;
  grid-row: 2 / span 4;
  animation-delay: calc(4 * var(--stagger-delay));
}
.card:nth-child(4) {
  grid-column: 1 / span 4;
  grid-row: 4 / span 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation-delay: calc(1 * var(--stagger-delay));
}
.border-4 {
  height: 100%;
  width: 100%;
  border-top: 6px solid black;
  border-bottom: 6px solid black;
  border-right: 6px solid black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-4 {
  height: 80%;
  width: 90%;
  background: black;
  color: white;
}
.wrapper-4 > div {
  height: 50%;
  font-family: "Source Serif Pro", serif;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10vw;
}
.angel {
  letter-spacing: 10px;
}
.card:nth-child(5) {
  grid-column: 1 / span 1;
  position: relative;
  animation-delay: calc(5 * var(--stagger-delay));
}

.bottom-left {
  border: 9px solid black;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 10px;
  margin-left: 15px;
  margin-right: 15px;
  overflow: hidden;
  background-size: cover;
  background-position: top;
  background-image: url("../assets/drawing3.jpg");
}
.card:nth-child(6) {
  grid-column: 2 / span 4;
  grid-row: 6 / span 1;
  position: relative;
  animation-delay: calc(4 * var(--stagger-delay));
}
.bottom-right {
  border: 8px solid black;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 10px;
  margin-left: 15px;
  margin-right: 15px;
  overflow: hidden;
  background-size: cover;
  background-position: top;
  background-image: url("../assets/drawing5.jpg");
}
.pluma {
  height: 100%;
  margin-left: 10px;
  margin-right: 15px;
}
.pluma > div {
  border: 5px solid black;
  height: 100%;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */

  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/pluma.jpg");
}
</style>



